module.exports = "img/flags/MP.9961559.png";